import { SoakingRequestDTO } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { Soaking } from '../soaking.entity';
import { SoakingRequestDto } from './soaking-request.dto';


@Injectable()
export class SoakingAdapter {
 
  public convertDtoToEntity(  soakingRequestDto: SoakingRequestDto,  isUpdate: boolean = false ): Soaking {
    const soakingEntitty = new Soaking();
    soakingEntitty.soakingId=soakingRequestDto.soakingId;
    soakingEntitty.assertId=soakingRequestDto.assertId;
    soakingEntitty.plantId=soakingRequestDto.plantId;
    soakingEntitty.StartTime=soakingRequestDto.StartTime;
    soakingEntitty.EndTime=soakingRequestDto.EndTime;
    soakingEntitty.duration=soakingRequestDto.duration;
    soakingEntitty.date=soakingRequestDto.date;
    soakingEntitty.isActive=soakingRequestDto.isActive==undefined?true:soakingRequestDto.isActive;
    if (isUpdate) {
      soakingEntitty.updatedUser = soakingRequestDto.updatedUser;
    } else {
      soakingEntitty.isActive = true;
      soakingEntitty.createdUser = soakingRequestDto.createdUser;
    }
   return soakingEntitty;
  }
  public convertEntityToDto(soakingObj: Soaking): SoakingRequestDto {
    const soakingDTO= new SoakingRequestDto;
    soakingDTO.soakingId = soakingObj.soakingId;
    soakingDTO.assertId = soakingObj.assertId;
    soakingDTO.plantId = soakingObj.plantId;
    soakingDTO.StartTime = soakingObj.StartTime;
    soakingDTO.EndTime = soakingObj.EndTime;
    soakingDTO.date = soakingObj.date;
    soakingDTO.duration = soakingObj.duration;
    soakingDTO.isActive = soakingObj.isActive;
    soakingDTO.createdAt = soakingObj.createdAt;
    soakingDTO.updatedAt = soakingObj.updatedAt;
    soakingDTO.createdUser = soakingObj.createdUser;
    soakingDTO.updatedUser = soakingObj.updatedUser;
    soakingDTO.versionFlag = soakingObj.versionFlag;
    return soakingDTO;
  }
}
